<div class="row">
  <div class="col-xl-6">
    <app-purchase-order-chart
      [productId]="productId"
      [barChartPeriod]="barChartPeriod"
      [xRotation]="-45"
    ></app-purchase-order-chart>
  </div>
  <div class="col-xl-6">
    <app-sales-order-chart
      [productId]="productId"
      [barChartPeriod]="barChartPeriod"
      [xRotation]="-45"
    ></app-sales-order-chart>
  </div>
</div>
